import React from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import LuckyIcon from '../../appearance/LuckyIcon';
import { PRIMARY_COLOR, WHITE } from '../../appearance/Colors';

/**
 * Deliberately blank — no marketing header/footer. This is a shared-content
 * preview, not a marketing page, and should read like a plain extension of
 * the in-app folder view (dark background, minimal chrome), not a landing
 * page. See docs/SHARING_AND_PUBLISHING_PLAN.md, Published Link section.
 */
const PublishedPageLayout = ({ children, headerContent = null, headerAction = null, fillViewport = false }) => {
    const history = useHistory();

    return (
        <Page $fillViewport={fillViewport}>
            <TopBar>
                <LogoButton onClick={() => history.push('/')} aria-label="Luckynote home">
                    <LuckyIcon sizeInPx={22} />
                    <LogoText>Luckynote</LogoText>
                </LogoButton>
                {headerAction ? <HeaderAction>{headerAction}</HeaderAction> : null}
                {headerContent ? <HeaderContent>{headerContent}</HeaderContent> : null}
            </TopBar>
            <Content>{children}</Content>
        </Page>
    );
};

const Page = styled.div`
    height: ${props => props.$fillViewport ? '100vh' : 'auto'};
    height: ${props => props.$fillViewport ? '100dvh' : 'auto'};
    overflow: ${props => props.$fillViewport ? 'hidden' : 'visible'};
    min-height: 100vh;
    min-height: 100dvh;
    background: ${PRIMARY_COLOR};
    color: ${WHITE};
    display: flex;
    flex-direction: column;
`;

const TopBar = styled.div`
    display: flex;
    align-items: center;
    gap: 18px;
    min-height: 62px;
    padding: 12px 20px;
    box-sizing: border-box;
    flex: 0 0 auto;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);

    @media (max-width: 620px) {
        align-items: flex-start;
        flex-wrap: wrap;
        gap: 8px 12px;
        padding: 10px 12px;
    }
`;

const LogoButton = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    flex: 0 0 auto;
    border: 0;
    background: transparent;
    color: ${WHITE};
    cursor: pointer;
    padding: 4px 6px;
    border-radius: 8px;

    &:hover { background: rgba(255, 255, 255, 0.06); }
`;

const LogoText = styled.span`
    font-size: 14px;
    font-weight: 600;
`;

const HeaderContent = styled.div`
    flex: 1 1 auto;
    min-width: 0;

    @media (max-width: 620px) {
        flex: 1 0 100%;
        width: 100%;
        order: 2;
    }
`;

const HeaderAction = styled.div`
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    flex: 0 0 auto;
    order: 3;

    @media (max-width: 620px) {
        order: 1;
        margin-left: auto;
    }
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0;
    background: ${PRIMARY_COLOR};
`;

export default PublishedPageLayout;
